import { configureStore } from '@reduxjs/toolkit'
import userReducer from '@store/user'
import absenteeReducer from '@store/absentee'
import reportReducer from '@store/report'
import memberReducer from '@store/member'
import boardReducer from '@store/board'
import companyAdminReducer from '@store/admin/company'
import reportAdminReducer from '@store/admin/report'
import memberAdminReducer from '@store/admin/member'
import boardAdminReducer from '@store/admin/board'
import boardContentAdminReducer from '@store/admin/boardContent'

export default configureStore({
  reducer: {
    user: userReducer,
    absentee: absenteeReducer,
    report: reportReducer,
    member: memberReducer,
    board: boardReducer,
    companyAdmin: companyAdminReducer,
    reportAdmin: reportAdminReducer,
    memberAdmin: memberAdminReducer,
    boardAdmin: boardAdminReducer,
    boardContentAdmin: boardContentAdminReducer
  }
})